<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <bonus-payment-type-create-or-update v-model="bonusType" :errors="errors"></bonus-payment-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="bonus-payment"
                    :buttons="buttons"
                    :fields="fields"
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import BonusPaymentTypeCreateOrUpdate from './components/BonusPaymentTypeCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        BonusPaymentTypeCreateOrUpdate
    },
    data(){
        return{
            loading:false,
            errors:{},
            editing:false,
            fields:[
                {name:"Prim Türü",key:"Name", thClass:"w-80",sortable:true},   
                {name:"Sıra",key:"Order", thClass:"w-20",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            bonusType:{
                Id:null,
                Name:null,
                Order:0
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.bonusType.Id = null
            this.bonusType.Name = null
            this.bonusType.Order = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.BonusPaymentType.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.bonusType.Id = item.Id
            this.bonusType.Name = item.Name
            this.bonusType.Order = item.Order
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            this.bonusType.Order = Number(this.bonusType.Order) || 0
            HumanResourcesParameterApi.BonusPaymentType.CreateOrUpdate(this.editing,this.bonusType).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} prim türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.BonusPaymentType.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>